import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./ErrorPage.css"
import {faBomb} from "@fortawesome/free-solid-svg-icons";
import {Button} from "@mantine/core";
import {useNavigate} from "react-router-dom";

export type ErrorPageProps = {
    heading?: string
    description?: string
    redirectText?: string
    redirectTo?: string
}

export function ErrorPage(props: ErrorPageProps) {
    const navigate = useNavigate();
    const redirectLink = props.redirectTo ? props.redirectTo : "/login";
    return (
        <div className="error-page">
            <h1>ER<span><FontAwesomeIcon icon={faBomb}/><FontAwesomeIcon icon={faBomb}/></span>R</h1>
            <h2>{props.heading ? props.heading : "Oops! Something went wrong.."}</h2>
            <p>{props.description ? props.description : "we couldn't find the resource you were looking for :)"}</p>
            <Button className={"error-page-button"} variant="outline"
                    onClick={() => navigate(redirectLink)}>{props.redirectText ? props.redirectTo : "Take Me to the Login Page!"}</Button>
        </div>
    );
}
